export const ENVIRONMENTS = Object.freeze({
  PRODUCTION: 'production',
  TEST: 'test',
  DEVELOPMENT: 'development',
});